export function publicationMetricText(metric) {
  return metric?.value==null || typeof metric.value!=='number' || !Number.isFinite(metric.value)
    ? '平台未提供' : `${metric.approximate ? '约 ' : ''}${metric.value}`
}
